import { render, staticRenderFns } from "./DropzoneFiles.vue?vue&type=template&id=e9b9ee08&scoped=true&"
import script from "./DropzoneFiles.vue?vue&type=script&lang=ts&"
export * from "./DropzoneFiles.vue?vue&type=script&lang=ts&"
import style0 from "./DropzoneFiles.vue?vue&type=style&index=0&id=e9b9ee08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b9ee08",
  null
  
)

export default component.exports